import { put, takeLatest, call, all } from "redux-saga/effects";

import {
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST,
  GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA,
  SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT,
  CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT,
  GET_BOM_COMPONENT_LIST,
  GET_BOM_COMPONENT_DATA,
  SEARCH_BOM_COMPONENT,
  CREATE_BOM_COMPONENT,
  UPDATE_BOM_COMPONENT,
  DELETE_BOM_COMPONENT,
  GET_BOM_LIST,
  GET_BOM_DATA,
  SEARCH_BOM,
  CREATE_BOM,
  UPDATE_BOM,
  DELETE_BOM,
  CREATE_BOM_VERSION,
  CLONE_BOM,
  SEARCH_PRODUCT_TO_BOM,
  GET_SALES_ORDER_BILL_OF_MATERIALS,
  SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE,
} from "./actionType";

import {
  getBomComponentSupplierProductListSuccess,
  getBomComponentSupplierProductListFailure,
  getBomComponentSupplierProductDataSuccess,
  getBomComponentSupplierProductDataFailure,
  searchBomComponentSupplierProductSuccess,
  searchBomComponentSupplierProductFailure,
  createBomComponentSupplierProductSuccess,
  createBomComponentSupplierProductFailure,
  updateBomComponentSupplierProductSuccess,
  updateBomComponentSupplierProductFailure,
  deleteBomComponentSupplierProductSuccess,
  deleteBomComponentSupplierProductFailure,
  getBomComponentListSuccess,
  getBomComponentListFailure,
  getBomComponentDataSuccess,
  getBomComponentDataFailure,
  searchBomComponentSuccess,
  searchBomComponentFailure,
  createBomComponentSuccess,
  createBomComponentFailure,
  updateBomComponentSuccess,
  updateBomComponentFailure,
  deleteBomComponentSuccess,
  deleteBomComponentFailure,
  getBomListSuccess,
  getBomListFailure,
  getBomDataSuccess,
  getBomDataFailure,
  searchBomSuccess,
  searchBomFailure,
  createBomSuccess,
  createBomFailure,
  updateBomSuccess,
  updateBomFailure,
  deleteBomSuccess,
  deleteBomFailure,
  createBomVersionSuccess,
  createBomVersionFailure,
  cloneBomSuccess,
  cloneBomFailure,
  searchProductToBomSuccess,
  searchProductToBomFailure,
  getSalesOrderBillOfMaterialsSuccess,
  getSalesOrderBillOfMaterialsFailure,
  searchProductBomToProductRuleSuccess,
  searchProductBomToProductRuleFailure,
} from "./action";

import {
  getBomComponentSupplierProductListApi,
  getBomComponentSupplierProductDataApi,
  searchBomComponentSupplierProductApi,
  createBomComponentSupplierProductApi,
  updateBomComponentSupplierProductApi,
  deleteBomComponentSupplierProductApi,
  getBomComponentListApi,
  getBomComponentDataApi,
  searchBomComponentApi,
  createBomComponentApi,
  updateBomComponentApi,
  deleteBomComponentApi,
  getBomListApi,
  getBomDataApi,
  searchBomApi,
  createBomApi,
  updateBomApi,
  deleteBomApi,
  createBomVersionApi,
  cloneBomApi,
  searchProductToBomApi,
  getSalesOrderBillOfMaterialsApi,
  searchProductBomToProductRuleApi,
} from "../../helpers/fakebackend_helper";

//SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE
function* searchProductBomToProductRuleSaga(action) {
  try {
    const response = yield call(
      searchProductBomToProductRuleApi,
      action.payload
    );
    yield put(searchProductBomToProductRuleSuccess(response));
  } catch (error) {
    yield put(searchProductBomToProductRuleFailure(error));
  }
}
function* watchSearchProductBomToProductRule() {
  yield takeLatest(
    SEARCH_PRODUCT_BOM_TO_PRODUCT_RULE,
    searchProductBomToProductRuleSaga
  );
}

//GET_SALES_ORDER_BILL_OF_MATERIALS
function* getSalesOrderBillOfMaterialsSaga(action) {
  try {
    const response = yield call(
      getSalesOrderBillOfMaterialsApi,
      action.payload
    );
    yield put(getSalesOrderBillOfMaterialsSuccess(response));
  } catch (error) {
    yield put(getSalesOrderBillOfMaterialsFailure(error));
  }
}
function* watchGetSalesOrderBillOfMaterials() {
  yield takeLatest(
    GET_SALES_ORDER_BILL_OF_MATERIALS,
    getSalesOrderBillOfMaterialsSaga
  );
}

//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST
function* getBomComponentSupplierProductListSaga() {
  try {
    const response = yield call(getBomComponentSupplierProductListApi);
    yield put(getBomComponentSupplierProductListSuccess(response));
  } catch (error) {
    yield put(getBomComponentSupplierProductListFailure(error));
  }
}
function* watchGetBomComponentSupplierProductList() {
  yield takeLatest(
    GET_BOM_COMPONENT_SUPPLIER_PRODUCT_LIST,
    getBomComponentSupplierProductListSaga
  );
}

//GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA
function* getBomComponentSupplierProductDataSaga(action) {
  try {
    const response = yield call(
      getBomComponentSupplierProductDataApi,
      action.payload
    );
    yield put(getBomComponentSupplierProductDataSuccess(response));
  } catch (error) {
    yield put(getBomComponentSupplierProductDataFailure(error));
  }
}
function* watchGetBomComponentSupplierProductData() {
  yield takeLatest(
    GET_BOM_COMPONENT_SUPPLIER_PRODUCT_DATA,
    getBomComponentSupplierProductDataSaga
  );
}
//SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT
function* searchBomComponentSupplierProductSaga(action) {
  try {
    const response = yield call(
      searchBomComponentSupplierProductApi,
      action.payload
    );
    yield put(searchBomComponentSupplierProductSuccess(response));
  } catch (error) {
    yield put(searchBomComponentSupplierProductFailure(error));
  }
}
function* watchSearchBomComponentSupplierProduct() {
  yield takeLatest(
    SEARCH_BOM_COMPONENT_SUPPLIER_PRODUCT,
    searchBomComponentSupplierProductSaga
  );
}
//CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT
function* createBomComponentSupplierProductSaga(action) {
  try {
    const response = yield call(
      createBomComponentSupplierProductApi,
      action.payload
    );
    yield put(createBomComponentSupplierProductSuccess(response));
  } catch (error) {
    yield put(createBomComponentSupplierProductFailure(error));
  }
}
function* watchCreateBomComponentSupplierProduct() {
  yield takeLatest(
    CREATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
    createBomComponentSupplierProductSaga
  );
}
//UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT
function* updateBomComponentSupplierProductSaga(action) {
  try {
    const response = yield call(
      updateBomComponentSupplierProductApi,
      action.payload
    );
    yield put(updateBomComponentSupplierProductSuccess(response));
  } catch (error) {
    yield put(updateBomComponentSupplierProductFailure(error));
  }
}
function* watchUpdateBomComponentSupplierProduct() {
  yield takeLatest(
    UPDATE_BOM_COMPONENT_SUPPLIER_PRODUCT,
    updateBomComponentSupplierProductSaga
  );
}
//DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT
function* deleteBomComponentSupplierProductSaga(action) {
  try {
    const response = yield call(
      deleteBomComponentSupplierProductApi,
      action.payload
    );
    yield put(deleteBomComponentSupplierProductSuccess(response));
  } catch (error) {
    yield put(deleteBomComponentSupplierProductFailure(error));
  }
}
function* watchDeleteBomComponentSupplierProduct() {
  yield takeLatest(
    DELETE_BOM_COMPONENT_SUPPLIER_PRODUCT,
    deleteBomComponentSupplierProductSaga
  );
}
//GET_BOM_COMPONENT_LIST
function* getBomComponentListSaga() {
  try {
    const response = yield call(getBomComponentListApi);
    yield put(getBomComponentListSuccess(response));
  } catch (error) {
    yield put(getBomComponentListFailure(error));
  }
}
function* watchGetBomComponentList() {
  yield takeLatest(GET_BOM_COMPONENT_LIST, getBomComponentListSaga);
}
//GET_BOM_COMPONENT_DATA
function* getBomComponentDataSaga(action) {
  try {
    const response = yield call(getBomComponentDataApi, action.payload);
    yield put(getBomComponentDataSuccess(response));
  } catch (error) {
    yield put(getBomComponentDataFailure(error));
  }
}
function* watchGetBomComponentData() {
  yield takeLatest(GET_BOM_COMPONENT_DATA, getBomComponentDataSaga);
}
//SEARCH_BOM_COMPONENT
function* searchBomComponentSaga(action) {
  try {
    const response = yield call(searchBomComponentApi, action.payload);
    yield put(searchBomComponentSuccess(response));
  } catch (error) {
    yield put(searchBomComponentFailure(error));
  }
}
function* watchSearchBomComponent() {
  yield takeLatest(SEARCH_BOM_COMPONENT, searchBomComponentSaga);
}
//CREATE_BOM_COMPONENT
function* createBomComponentSaga(action) {
  try {
    const response = yield call(createBomComponentApi, action.payload);
    yield put(createBomComponentSuccess(response));
  } catch (error) {
    yield put(createBomComponentFailure(error));
  }
}
function* watchCreateBomComponent() {
  yield takeLatest(CREATE_BOM_COMPONENT, createBomComponentSaga);
}
//UPDATE_BOM_COMPONENT
function* updateBomComponentSaga(action) {
  try {
    const response = yield call(updateBomComponentApi, action.payload);
    yield put(updateBomComponentSuccess(response));
  } catch (error) {
    yield put(updateBomComponentFailure(error));
  }
}
function* watchUpdateBomComponent() {
  yield takeLatest(UPDATE_BOM_COMPONENT, updateBomComponentSaga);
}
//DELETE_BOM_COMPONENT
function* deleteBomComponentSaga(action) {
  try {
    const response = yield call(deleteBomComponentApi, action.payload);
    yield put(deleteBomComponentSuccess(response));
  } catch (error) {
    yield put(deleteBomComponentFailure(error));
  }
}
function* watchDeleteBomComponent() {
  yield takeLatest(DELETE_BOM_COMPONENT, deleteBomComponentSaga);
}
//GET_BOM_LIST
function* getBomListSaga() {
  try {
    const response = yield call(getBomListApi);
    yield put(getBomListSuccess(response));
  } catch (error) {
    yield put(getBomListFailure(error));
  }
}
function* watchGetBomList() {
  yield takeLatest(GET_BOM_LIST, getBomListSaga);
}
//GET_BOM_DATA
function* getBomDataSaga(action) {
  try {
    const response = yield call(getBomDataApi, action.payload);
    yield put(getBomDataSuccess(response));
  } catch (error) {
    yield put(getBomDataFailure(error));
  }
}
function* watchGetBomData() {
  yield takeLatest(GET_BOM_DATA, getBomDataSaga);
}
//SEARCH_BOM
function* searchBomSaga(action) {
  try {
    const response = yield call(searchBomApi, action.payload);
    yield put(searchBomSuccess(response));
  } catch (error) {
    yield put(searchBomFailure(error));
  }
}
function* watchSearchBom() {
  yield takeLatest(SEARCH_BOM, searchBomSaga);
}
//CREATE_BOM
function* createBomSaga(action) {
  try {
    const response = yield call(createBomApi, action.payload);
    yield put(createBomSuccess(response));
  } catch (error) {
    yield put(createBomFailure(error));
  }
}
function* watchCreateBom() {
  yield takeLatest(CREATE_BOM, createBomSaga);
}
//UPDATE_BOM
function* updateBomSaga(action) {
  try {
    const response = yield call(updateBomApi, action.payload);
    yield put(updateBomSuccess(response));
  } catch (error) {
    yield put(updateBomFailure(error));
  }
}
function* watchUpdateBom() {
  yield takeLatest(UPDATE_BOM, updateBomSaga);
}
//DELETE_BOM
function* deleteBomSaga(action) {
  try {
    const response = yield call(deleteBomApi, action.payload);
    yield put(deleteBomSuccess(response));
  } catch (error) {
    yield put(deleteBomFailure(error));
  }
}
function* watchDeleteBom() {
  yield takeLatest(DELETE_BOM, deleteBomSaga);
}
//CREATE_BOM_VERSION
function* createBomVersionSaga(action) {
  try {
    const response = yield call(createBomVersionApi, action.payload);
    yield put(createBomVersionSuccess(response));
  } catch (error) {
    yield put(createBomVersionFailure(error));
  }
}
function* watchCreateBomVersion() {
  yield takeLatest(CREATE_BOM_VERSION, createBomVersionSaga);
}
//CLONE_BOM
function* cloneBomSaga(action) {
  try {
    const response = yield call(cloneBomApi, action.payload);
    yield put(cloneBomSuccess(response));
  } catch (error) {
    yield put(cloneBomFailure(error));
  }
}
function* watchCloneBom() {
  yield takeLatest(CLONE_BOM, cloneBomSaga);
}
// Root saga to combine all BOM sagas
export default function* bomSaga() {
  yield all([
    watchGetSalesOrderBillOfMaterials(),
    watchSearchProductBomToProductRule(),
    watchGetBomComponentSupplierProductList(),
    watchGetBomComponentSupplierProductData(),
    watchSearchBomComponentSupplierProduct(),
    watchCreateBomComponentSupplierProduct(),
    watchUpdateBomComponentSupplierProduct(),
    watchDeleteBomComponentSupplierProduct(),
    watchGetBomComponentList(),
    watchGetBomComponentData(),
    watchSearchBomComponent(),
    watchCreateBomComponent(),
    watchUpdateBomComponent(),
    watchDeleteBomComponent(),
    watchGetBomList(),
    watchGetBomData(),
    watchSearchBom(),
    watchCreateBom(),
    watchUpdateBom(),
    watchDeleteBom(),
    watchCreateBomVersion(),
    watchCloneBom(),
  ]);
}
